const $ = require('jquery');

// move widget on mobile (below description)
$('body.single-course .sidebar-layout .widgets').each(function() {
    let $widgets = $(this);

    moveWidgets($widgets);
    $(window).on('resize', function() {
        moveWidgets($widgets);
    });
});

function moveWidgets($widgets = false) {
    if (!$widgets) return false;

    let $content = $widgets.closest('.sidebar-layout').find('.sidebar-layout__content'),
        $sidebar = $widgets.closest('.sidebar-layout').find('.sidebar-layout__sidebar');

    if (viewport().width < 1200) {
        // first check if widgets have not been moved already (still inside sidebar-layout__sidebar)
        if ($widgets.closest('.sidebar-layout__sidebar').length > 0) {
            $sidebar.hide();
            $widgets.insertBefore($content.find('.tabs'));
        }
    } else {
        // first check if widgets have not been moved already (not inside sidebar-layout__sidebar anymore)
        if (!$widgets.closest('.sidebar-layout__sidebar').length > 0) {
            $widgets.appendTo($sidebar.find('.sidebar-layout__sticky'));
            $sidebar.show();
        }
    }
}